// extracted by mini-css-extract-plugin
export default {"CaseSearchContainer":"vDuLu2BX","textFieldWrapper":"zt2I7LxO"};